module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "epigraph",
    attrs: {
      "epub:type": "epigraph"
    }
  }, [_c('blockquote', {
    staticClass: "hanging_indent bq"
  }, [_c('p', {
    staticClass: "no_header firstInSection"
  }, [_vm._v("Children of the martyr-race,")]), _vm._v(" "), _c('p', [_vm._v("Whether free or fettered,")]), _vm._v(" "), _c('p', [_vm._v("Wake the echoes of the songs,")]), _vm._v(" "), _c('p', [_vm._v("Where ye may be scattered.")]), _vm._v(" "), _c('p', [_vm._v("Yours the message cheering,")]), _vm._v(" "), _c('p', [_vm._v("That the time is nearing,")]), _vm._v(" "), _c('p', [_vm._v("Which will see all men free,")]), _vm._v(" "), _c('p', [_vm._v("Tyrants disappearing.")])]), _vm._v(" "), _c('p', {
    staticClass: "right firstInSection"
  }, [_vm._v("From a "), _c('em', [_vm._v("Chanukah")]), _vm._v(" hymn")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 69
// module chunks = 0